if (!customElements.get('subscription-selector')) {
  customElements.define('subscription-selector', class SubscriptionSelector extends HTMLElement {
    constructor() {
      super();
      this.onRadioChange = this.onRadioChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.sellingPlanInput = document.getElementById(`selling-plan-${this.sectionId}`);
      this.radios = this.querySelectorAll('.subscription-selector__radio');
      this.radios.forEach(radio => {
        radio.addEventListener('change', this.onRadioChange);
      });
      this.variantChangeUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    disconnectedCallback() {
      this.radios.forEach(radio => radio.removeEventListener('change', this.onRadioChange));
      if (this.variantChangeUnsubscribe) this.variantChangeUnsubscribe();
    }

    onRadioChange(event) {
      const radio = event.target;
      this.querySelectorAll('.subscription-selector__option').forEach(option => {
        option.classList.remove('subscription-selector__option--selected');
        const benefits = option.querySelector('.subscription-selector__benefits');
        if (benefits) benefits.hidden = true;
      });
      const option = radio.closest('.subscription-selector__option');
      option.classList.add('subscription-selector__option--selected');
      if (radio.dataset.radioType === 'selling_plan') {
        const benefits = option.querySelector('.subscription-selector__benefits');
        if (benefits) benefits.hidden = false;
        this.sellingPlanInput.value = radio.dataset.sellingPlanId;
      } else {
        this.sellingPlanInput.value = '';
      }
    }

    onVariantChange(event) {
      const variant = event.data?.variant;
      if (!variant) return;
      const availablePlanIds = variant.selling_plan_allocations
        ? variant.selling_plan_allocations.map(a => String(a.selling_plan_id))
        : [];
      const currentPlanId = this.sellingPlanInput.value;
      this.querySelectorAll('.subscription-selector__radio[data-radio-type="selling_plan"]').forEach(radio => {
        const option = radio.closest('.subscription-selector__option');
        if (availablePlanIds.length === 0 || !availablePlanIds.includes(radio.dataset.sellingPlanId)) {
          option.style.display = 'none';
        } else {
          option.style.display = '';
        }
      });
      if (!currentPlanId || !availablePlanIds.includes(currentPlanId)) {
        const oneTimeRadio = this.querySelector('.subscription-selector__radio[data-radio-type="one_time_purchase"]');
        if (oneTimeRadio) {
          oneTimeRadio.checked = true;
          oneTimeRadio.dispatchEvent(new Event('change'));
        }
      }
    }

  });
}
